import React from "react";
import { DocumentCard, 
    DocumentCardDetails, 
    DocumentCardTitle, 
    DocumentCardActivity, 
    DocumentCardLocation, 
    Icon,
    TooltipHost,
    DefaultButton} from '@fluentui/react';
import { attentionMessages } from '../../GlobalConst/attentionMessages';
import { LocationType, ProvisioningStatus, SiteStatus } from '../../GlobalConst/globalEnums';
import EditModal from "../EditSite/EditModal";
import InfoTooltip from "../formFields/InfoTooltip";
import { renderDateTime, renderQuotaUsage } from "../../helpers/HelperMethods";

class SingleSite extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            isMsTeams: this.props.site.siteTemplate.siteType === 'Team',
            isGroup: this.props.site.siteTemplate.siteType === 'Group'
        }
    }

    _onEditClick = () => {
        this.setState({showModal: true})
    }

    _onLocationClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        window.open(e.target.href, '_blank');
    }

    _mapOwnerForPeople(user) {
        return [{
            name: user ? user.displayName : ''
        }];
    }

    _closeModal = () => {
        //this.props.onModalClosed();
        this.setState({showModal: false})
    }

    render() {
        var attentionIcon = null;
        var attentions = this.props.site.attentions.filter(a => a.isValid);
        if(attentions.length) {
            const attentionText = attentions.map((a, i) => <span key={i}>{attentionMessages[a.type]}<br/></span>);
            attentionIcon = <TooltipHost content={attentionText} styles={iconStyles}>
                                <Icon iconName='important' style={attentionIconStyles} />
                            </TooltipHost>
        }

        var updatesIcon = null;
        if(!this.state.isGroup && ![ProvisioningStatus.ready, ProvisioningStatus.readOnly, ProvisioningStatus.noAccess, ProvisioningStatus.ms365Archived].includes(this.props.site.provisioningStatus)) {
            updatesIcon = <TooltipHost content='Updates are in progress' styles={iconStyles}>
                            <Icon iconName='workflow' style={updatesIconStyles} />
                        </TooltipHost>
        }

        const toolTipContent =  <div>
                                    <div style={{fontWeight:'bold', marginBottom:'4px'}}>Reject reason: </div>
                                    <div style={{width: '250px'}}>{this.props.site.approverComment}</div>
                                </div>

        const tooltip = this.props.site.siteStatus === "Rejected" ? <InfoTooltip content={toolTipContent}/> : null;

        var btnEdit = <DefaultButton text='Edit' onClick={this._onEditClick} styles={btnEditStyles} />;
        if((this.state.isGroup || updatesIcon || ![SiteStatus.active, SiteStatus.deleted, SiteStatus.expired, SiteStatus.archived].includes(this.props.site.siteStatus))) {
            btnEdit = null;
        }
        const logo = <span className={`cardLogo ${this.state.isGroup ? 'groupLogo' : (this.state.isMsTeams ? 'teamsLogo' : 'spLogo')}`} />


        const showExceedingFreeQuotaBanner =
            this.props.site.siteTemplate.location.locationType === LocationType.online 
            && this.props.site.siteStatus === SiteStatus.active 
            && this.props.site.quotaUsage > 10240 //10 GB

        const exceedingFreeQuotaBanner = 
            showExceedingFreeQuotaBanner &&
            <div style={{backgroundColor: '#d13438', color: 'white', padding: '5px 8px', fontWeight: 'bold'}}>
                EXCEEDING FREE STORAGE LIMIT
            </div>

        const showApproachingFreeQuotaBanner =
            this.props.site.siteTemplate.location.locationType === LocationType.online 
            && this.props.site.siteStatus === SiteStatus.active 
            && this.props.site.quotaUsage >= 8192 && this.props.site.quotaUsage <= 10240 //8 - 10 GB

        const approachingFreeQuotaBanner = 
            showApproachingFreeQuotaBanner &&
            <div style={{backgroundColor: '#ffb900', color: 'white', padding: '5px 8px', fontWeight: 'bold'}}>
                APPROACHING FREE STORAGE LIMIT
            </div>

        const customBorder =
            showExceedingFreeQuotaBanner 
            ? '1px solid #d13438'
            : showApproachingFreeQuotaBanner
                ? '1px solid #ffb900'
                : null

        const provisioningStatus = [SiteStatus.archived, SiteStatus.deleted, SiteStatus.expired, SiteStatus.disabled].includes(this.props.site.siteStatus) && ` (${this.props.site.provisioningStatus})`

        return (
            <div>
                <DocumentCard styles={this.state.isMsTeams ? teamsCardStyles(customBorder) : spCardStyles(customBorder)} >
                    <DocumentCardDetails styles={detailsStyles} >
                        {exceedingFreeQuotaBanner}
                        {approachingFreeQuotaBanner}
                        <div style={headerStyles}>
                            {logo}
                            <div style={titleContainerStyles}>
                                <DocumentCardTitle title={this.props.site.title} shouldTruncate={false} styles={titleStyles} />
                            </div>
                            <div style={iconContainerStyles}>
                                {attentionIcon}
                                {updatesIcon}
                                {btnEdit}
                            </div>
                        </div>
                        {
                            this.props.site.url && this.props.site.siteStatus !== SiteStatus.creating &&
                            <DocumentCardLocation 
                                styles={urlStyles} 
                                location={this.props.site.url} 
                                locationHref={this.props.site.url} 
                                onClick={this._onLocationClick} />
                        }
                        <div style={statusStyles}>{`Status: ${this.props.site.siteStatus}`}{provisioningStatus} {tooltip}</div>
                        {
                            this.props.site.url && this.props.site.siteStatus !== SiteStatus.creating &&
                            <div style={quotaUsageStyles}>Quota usage: {renderQuotaUsage(this.props.site.quotaUsage, this.props.site.quotaValue, this.props.site.statistics ? this.props.site.statistics.storageUsedMB : null)}</div>
                        }
                        <div style={createdByStyles}>Created by: </div>
                    </DocumentCardDetails>
                    <DocumentCardActivity 
                        activity={`Created on ${renderDateTime(this.props.site.created)}`} 
                        people={this._mapOwnerForPeople(this.props.site.author)} 
                    />
                </DocumentCard>
                <EditModal 
                    onCloseModal={this._closeModal} 
                    isModalOpened={this.state.showModal} 
                    itemId={this.props.site.id}
                    callBack={this.props.callBack}
                    isPowerApp={false}
                />
            </div>
        );
    }
}
const urlStyles = {
    root: {
        color: 'rgb(0, 120, 212)',
        padding: '3px 16px'
    }
}
const statusStyles = {
    padding: '3px 16px',
    fontSize: '12px'
}

const quotaUsageStyles = {
    padding: '3px 16px',
    fontSize: '12px'
}

const createdByStyles = {
    padding: '3px 16px 0',
    fontSize: '12px'
}

const btnEditStyles = {
    root: {
        margin: '6px',
        height: '24px',
        minWidth: '40px'
    },
    label: {
        fontWeight: 400
    }
}

const iconContainerStyles = {
    display: 'flex'
}

const iconStyles = {
    root: {
        margin: '10px 10px 10px 0'
    }
}

const attentionIconStyles = {
    color: 'red'
}

const updatesIconStyles = {
    color: 'orange'
}

const titleStyles = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}

const cardStyles = {
    root: {  
        marginRight: 20, 
        marginBottom: 20, 
        width: 400,
    }
};


const teamsCardStyles = (border) => ({
    ...cardStyles,
    root: {  
        ...cardStyles.root,
        border: border ? border : '1px solid rgb(68, 71, 145)'
    }
})


const spCardStyles = (border) => ({
    ...cardStyles,
    root: {  
        ...cardStyles.root,
        border: border ? border : '1px solid rgb(0, 120, 212)'
    }
})

const detailsStyles = {
    root: {
        height: 170
    }
}

const headerStyles = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}

const titleContainerStyles = {
    display: 'flex',
    height: 54,
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden'
}

export default SingleSite


// WEBPACK FOOTER //
// ./src/components/ManageCenter/SingleSite.js